<nz-layout class="tracker-detail-layout">
  <nz-header>
    <nz-tabset nzType="card" [nzTabBarExtraContent]="extraTemplate">
      <nz-tab [nzTitle]="titleTemplate">
        <ng-template #titleTemplate>
          <div class="tab-title">
            <button
              nz-button
              nzType="text"
              class="back-button"
              (click)="goBack(); $event.stopPropagation()"
            >
              <span
                nz-icon
                nzType="arrow-left"
                nzTheme="outline"
                class="back-icon"
              ></span>
            </button>
            <span>Rastreador — {{ chassis | uppercase }}</span>
          </div>
        </ng-template>
      </nz-tab>
    </nz-tabset>

    <ng-template #extraTemplate>
      <div class="period-bar">
        <button
          nz-button
          [nzType]="periodPreset === '30d' ? 'primary' : 'default'"
          (click)="setPeriodPreset('30d')"
        >
          30 dias
        </button>
        <button
          nz-button
          [nzType]="periodPreset === 'today' ? 'primary' : 'default'"
          (click)="setPeriodPreset('today')"
        >
          Hoje
        </button>
        <button
          nz-button
          [nzType]="periodPreset === '7d' ? 'primary' : 'default'"
          (click)="setPeriodPreset('7d')"
        >
          7 dias
        </button>
        <nz-range-picker
          class="period-bar__picker"
          [(ngModel)]="dateRange"
          (ngModelChange)="onCustomRangeChange($event)"
          nzFormat="dd/MM/yyyy"
        ></nz-range-picker>
      </div>
    </ng-template>
  </nz-header>

  <nz-content>
    <nz-spin [nzSpinning]="loading">
      @if (errorMessage) {
        <nz-alert
          class="tracker-detail-alert"
          nzType="error"
          nzShowIcon
          [nzMessage]="errorMessage"
        ></nz-alert>
      }

      <div class="tracker-detail-body">
        @if (statistics) {
          <div class="vehicle-hero">
            <div class="vehicle-hero__media">
              <az_avatar
                [fullHeight]="true"
                [fullWidth]="true"
                [shape]="'square'"
                [src]="revision?.product_image || undefined"
                icon="directions_car"
              ></az_avatar>
            </div>

            <div class="vehicle-hero__info">
              <div class="vehicle-hero__title-row">
                <div>
                  <p class="vehicle-hero__eyebrow">Detalhe do rastreador</p>
                  <h1>{{ revision?.product_name || 'Veículo' }}</h1>
                  <p class="vehicle-hero__plate">{{ chassis | uppercase }}</p>
                </div>
                <nz-tag [nzColor]="motionMoving ? 'success' : 'default'">
                  {{ motionLabel }}
                </nz-tag>
              </div>

              <p class="vehicle-hero__meta">
                <i nz-icon nzType="clock-circle"></i>
                Última posição:
                {{
                  statistics.lastPosition?.recordedAt
                    ? (statistics.lastPosition!.recordedAt | date: 'dd/MM/yyyy HH:mm')
                    : '—'
                }}
                @if (revision?.product_name) {
                  · {{ revision!.product_name }}
                }
              </p>
              @if (statistics.trailTruncated) {
                <p class="vehicle-hero__hint">
                  Trilha amostrada ({{ statistics.trailSample.length }} de
                  {{ statistics.pointsCount }} pontos)
                </p>
              }
              @if (statistics.hasPartialCoverage && statistics.dataFrom) {
                <p class="vehicle-hero__hint vehicle-hero__hint--coverage">
                  Histórico GPS disponível desde
                  {{ statistics.dataFrom | date: 'dd/MM/yyyy HH:mm' }}
                  @if (statistics.dataTo) {
                    até {{ statistics.dataTo | date: 'dd/MM/yyyy HH:mm' }}
                  }
                  — métricas calculadas apenas com dados ingeridos no período.
                </p>
              }
            </div>
          </div>

          <div class="metrics-grid">
            <div class="metric-card">
              <span class="metric-card__label">Km checklist</span>
              <strong class="metric-card__value">
                {{
                  revision?.current_km != null
                    ? (revision!.current_km | number: '1.0-0')
                    : '—'
                }}
              </strong>
              <span class="metric-card__unit">último checklist</span>
            </div>
            <div class="metric-card">
              <span class="metric-card__label">Km última revisão</span>
              <strong class="metric-card__value">
                {{
                  revision?.last_revision_km != null
                    ? (revision!.last_revision_km | number: '1.0-0')
                    : '—'
                }}
              </strong>
              <span class="metric-card__unit">configurado</span>
            </div>
            <div class="metric-card metric-card--accent">
              <span class="metric-card__label">Km estimados (GPS)</span>
              <strong class="metric-card__value">
                {{ statistics.distanceKm | number: '1.0-1' }}
              </strong>
              <span class="metric-card__unit">
                @if (statistics.hasPartialCoverage) {
                  com dados ingeridos
                } @else {
                  no período
                }
              </span>
            </div>
            <div class="metric-card">
              <span class="metric-card__label">Vel. máxima</span>
              <strong class="metric-card__value">{{ statistics.maxSpeed }}</strong>
              <span class="metric-card__unit">km/h · média {{ statistics.avgSpeed }}</span>
            </div>
            <div class="metric-card">
              <span class="metric-card__label">Tempo em movimento</span>
              <strong class="metric-card__value">
                {{ formatDuration(statistics.movingTimeSec) }}
              </strong>
              <span class="metric-card__unit">
                parado {{ formatDuration(statistics.stoppedTimeSec) }}
              </span>
            </div>
            <div class="metric-card">
              <span class="metric-card__label">Ignição ligada</span>
              <strong class="metric-card__value">
                {{ formatDuration(statistics.ignitionOnTimeSec) }}
              </strong>
              <span class="metric-card__unit">
                {{ statistics.pointsCount | number }} pontos
              </span>
            </div>
          </div>
        }

        <div class="detail-columns">
          <!-- Map stays in DOM (not gated by @if) so Leaflet can mount reliably -->
          <div class="detail-columns__main trail-panel">
            <div class="panel-header">
              <strong>Trilha no período</strong>
              <span>{{ trailPointCount }} pontos no mapa</span>
            </div>
            <div class="trail-map">
              <div #trailMapContainer class="trail-map__canvas"></div>
              @if (!loading && statistics && trailPointCount === 0) {
                <div class="trail-map__empty">
                  <nz-empty
                    nzNotFoundImage="simple"
                    nzNotFoundContent="Sem pontos de movimento no período"
                  ></nz-empty>
                </div>
              }
            </div>
          </div>

          @if (!errorMessage && chassis) {
            <div class="detail-columns__side costs-summary">
              <div class="costs-summary__header">
                <strong>Custos no período</strong>
                <button
                  nz-button
                  nzType="primary"
                  nzSize="small"
                  (click)="openCreateFine()"
                >
                  <i nz-icon nzType="plus"></i>
                  Nova multa
                </button>
              </div>

              <div class="costs-summary__total">
                <span class="costs-summary__total-label">Custo total</span>
                <strong class="costs-summary__total-value">
                  {{ formatCurrency(fineSummary?.total_amount) }}
                </strong>
                <span class="costs-summary__total-sub">
                  {{ fineSummary?.total_count || 0 }} multa(s)
                </span>
              </div>

              <div class="costs-summary__split">
                <div class="costs-chip costs-chip--paid">
                  <span class="costs-chip__label">Pago</span>
                  <strong class="costs-chip__value">
                    {{ formatCurrency(fineSummary?.paid_amount) }}
                  </strong>
                  <small>{{ fineSummary?.paid_count || 0 }} paga(s)</small>
                </div>
                <div class="costs-chip costs-chip--open">
                  <span class="costs-chip__label">Em aberto</span>
                  <strong class="costs-chip__value">
                    {{ formatCurrency(fineSummary?.unpaid_amount) }}
                  </strong>
                  <small>{{ fineSummary?.unpaid_count || 0 }} em aberto</small>
                </div>
              </div>
            </div>
          }
        </div>

        @if (!errorMessage && chassis) {
          <div class="detail-tabs">
            <nz-tabset nzType="line">
              <nz-tab nzTitle="Multas">
                <nz-table
                  #finesTable
                  nzSize="middle"
                  [nzData]="fines"
                  [nzFrontPagination]="false"
                  [nzLoading]="finesLoading"
                  [nzTotal]="finesTotal"
                  [nzPageIndex]="finesPageIndex"
                  [nzPageSize]="finesPageSize"
                  [nzShowPagination]="finesTotal > finesPageSize"
                  (nzPageIndexChange)="onFinesPageChange($event)"
                >
                  <thead>
                    <tr>
                      <th>Data</th>
                      <th>Descrição</th>
                      <th>Valor</th>
                      <th>Status</th>
                      <th class="fines-actions-col">Ações</th>
                    </tr>
                  </thead>
                  <tbody>
                    @for (fine of finesTable.data; track fine.id) {
                      <tr>
                        <td>{{ fine.fine_date | date: 'dd/MM/yyyy' }}</td>
                        <td>{{ fine.description || '—' }}</td>
                        <td>{{ formatCurrency(fine.amount) }}</td>
                        <td>
                          <nz-tag [nzColor]="fineStatusColor(fine.status)">
                            {{ fineStatusLabel(fine.status) }}
                          </nz-tag>
                        </td>
                        <td class="fines-actions">
                          <button
                            nz-button
                            nzType="text"
                            nzSize="small"
                            [title]="
                              fine.status === FineStatusEnum.PAID
                                ? 'Marcar em aberto'
                                : 'Marcar como paga'
                            "
                            (click)="toggleFineStatus(fine)"
                          >
                            <i
                              nz-icon
                              [nzType]="
                                fine.status === FineStatusEnum.PAID
                                  ? 'undo'
                                  : 'check-circle'
                              "
                            ></i>
                          </button>
                          <button
                            nz-button
                            nzType="text"
                            nzSize="small"
                            title="Editar"
                            (click)="openEditFine(fine)"
                          >
                            <i nz-icon nzType="edit"></i>
                          </button>
                          <button
                            nz-button
                            nzType="text"
                            nzSize="small"
                            nzDanger
                            title="Excluir"
                            nz-popconfirm
                            nzPopconfirmTitle="Remover esta multa?"
                            (nzOnConfirm)="deleteFine(fine)"
                          >
                            <i nz-icon nzType="delete"></i>
                          </button>
                        </td>
                      </tr>
                    }
                  </tbody>
                  <ng-template nzNoResult>
                    <nz-empty
                      nzNotFoundImage="simple"
                      nzNotFoundContent="Nenhuma multa lançada"
                    ></nz-empty>
                  </ng-template>
                </nz-table>
              </nz-tab>

              <nz-tab nzTitle="Movimentos">
                @if (statistics) {
                  <nz-table
                    #movementsTable
                    nzSize="middle"
                    [nzData]="movements"
                    [nzFrontPagination]="false"
                    [nzLoading]="movementsLoading"
                    [nzTotal]="movementsTotal"
                    [nzPageIndex]="movementsPageIndex"
                    [nzPageSize]="movementsPageSize"
                    [nzShowTotal]="totalTpl"
                    (nzPageIndexChange)="onMovementsPageChange($event)"
                  >
                    <thead>
                      <tr>
                        <th>Data/hora</th>
                        <th>Velocidade</th>
                        <th>Ignição</th>
                        <th>Latitude</th>
                        <th>Longitude</th>
                      </tr>
                    </thead>
                    <tbody>
                      @for (row of movementsTable.data; track row.recordedAt + row.latitude) {
                        <tr>
                          <td>{{ row.recordedAt | date: 'dd/MM/yyyy HH:mm:ss' }}</td>
                          <td>{{ row.speed }} km/h</td>
                          <td>{{ formatIgnition(row.ignition) }}</td>
                          <td>{{ row.latitude | number: '1.5-5' }}</td>
                          <td>{{ row.longitude | number: '1.5-5' }}</td>
                        </tr>
                      }
                    </tbody>
                  </nz-table>

                  <ng-template #totalTpl let-total>
                    {{ total }} movimentos
                  </ng-template>
                } @else {
                  <nz-empty
                    nzNotFoundImage="simple"
                    nzNotFoundContent="Sem movimentos no período"
                  ></nz-empty>
                }
              </nz-tab>
            </nz-tabset>
          </div>
        }

        @if (!loading && !errorMessage && !statistics) {
          <div class="tracker-detail-empty">
            <nz-empty nzNotFoundContent="Sem dados para esta placa"></nz-empty>
          </div>
        }
      </div>
    </nz-spin>
  </nz-content>
</nz-layout>

<nz-modal
  [(nzVisible)]="fineModalVisible"
  [nzTitle]="fineModalMode === 'edit' ? 'Editar multa' : 'Nova multa'"
  [nzOkLoading]="fineSaving"
  nzOkText="Salvar"
  nzCancelText="Cancelar"
  (nzOnCancel)="closeFineModal()"
  (nzOnOk)="submitFine()"
>
  <ng-container *nzModalContent>
    <div class="fine-form">
      <label class="fine-form__field">
        <span class="fine-form__label">Valor (R$)</span>
        <input
          nz-input
          class="fine-form__control"
          inputmode="numeric"
          [ngModel]="fineAmountDisplay"
          (ngModelChange)="onFineAmountInput($event)"
          placeholder="R$ 0,00"
        />
      </label>

      <label class="fine-form__field">
        <span class="fine-form__label">Data</span>
        <nz-date-picker
          class="fine-form__control"
          [(ngModel)]="fineForm.fine_date"
          nzFormat="dd/MM/yyyy"
        ></nz-date-picker>
      </label>

      <label class="fine-form__field">
        <span class="fine-form__label">Status</span>
        <nz-select class="fine-form__control" [(ngModel)]="fineForm.status">
          <nz-option
            [nzValue]="FineStatusEnum.UNPAID"
            nzLabel="Em aberto"
          ></nz-option>
          <nz-option
            [nzValue]="FineStatusEnum.PAID"
            nzLabel="Paga"
          ></nz-option>
        </nz-select>
      </label>

      <label class="fine-form__field">
        <span class="fine-form__label">Descrição (opcional)</span>
        <input
          nz-input
          class="fine-form__control"
          [(ngModel)]="fineForm.description"
          placeholder="Ex.: Excesso de velocidade"
        />
      </label>
    </div>
  </ng-container>
</nz-modal>
